import { render, staticRenderFns } from "./NominateOrDepositChoice.vue?vue&type=template&id=4a484578&"
import script from "./NominateOrDepositChoice.vue?vue&type=script&lang=js&"
export * from "./NominateOrDepositChoice.vue?vue&type=script&lang=js&"
import style0 from "./NominateOrDepositChoice.vue?vue&type=style&index=0&id=4a484578&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports